import React, { useState, useRef, useEffect } from 'react';
import { Flag } from 'lucide-react';
import toast from 'react-hot-toast';
import { submitDataReport } from '../services/featureDb';

interface Props {
  forumId: string;
  darkMode: boolean;
}

const DataReportButton: React.FC<Props> = ({ forumId, darkMode }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [sending, setSending] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const send = async () => {
    setSending(true);
    const { ok, error } = await submitDataReport(forumId, msg || 'İstatistikler hatalı görünüyor');
    setSending(false);
    if (ok) {
      toast.success('Bildiriminiz alındı, teşekkürler');
      setOpen(false);
      setMsg('');
    } else {
      toast.error(error || 'Gönderilemedi, lütfen tekrar deneyin');
    }
  };

  const panel = darkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200';
  const input = darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-200';

  return (
    <div className="w-full sm:w-auto" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`text-sm flex items-center gap-1.5 px-2 py-1 rounded-lg border ${
          open
            ? 'border-indigo-500 text-indigo-500'
            : darkMode
              ? 'border-gray-600 text-gray-300 hover:border-gray-500'
              : 'border-gray-200 text-gray-600 hover:border-gray-300'
        }`}
        aria-expanded={open}
      >
        <Flag size={14} /> Veri hatalı mı?
      </button>
      {open && (
        <div className={`mt-2 p-3 rounded-lg border shadow-lg w-full max-w-md ${panel}`}>
          <p className={`text-xs mb-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            İstatistik veya bilgide hata görüyorsanız kısaca yazın; ekibimiz inceler.
          </p>
          <textarea
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            placeholder="Örn. üye sayısı güncel değil"
            rows={3}
            className={`w-full text-sm rounded border p-2 mb-2 ${input}`}
          />
          <div className="flex gap-2">
            <button
              type="button"
              disabled={sending}
              onClick={send}
              className="flex-1 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
            >
              {sending ? 'Gönderiliyor…' : 'Gönder'}
            </button>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className={`px-3 py-2 text-sm rounded-lg border ${darkMode ? 'border-gray-600' : 'border-gray-200'}`}
            >
              İptal
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataReportButton;
